import React, { useState } from "react";
import {
    PayPalScriptProvider,
    PayPalButtons,
    usePayPalScriptReducer
} from "@paypal/react-paypal-js";

const DonateButton = () => {
    const [donationAmount, setDonationAmount] = useState(0);
    const style = {"layout":"vertical"};
    const createOrder = async () => {
        // replace this url with your server
        return fetch("https://react-paypal-js-storybook.fly.dev/api/paypal/create-order", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            // use the "body" param to optionally pass additional order information
            // like product ids and quantities
            body: JSON.stringify({
                cart: [
                    {
                        amounnt: donationAmount,
                    },
                ],
            }),
        })
            .then((response) => response.json())
            .then((order) => {
                // Your code here after create the order
                return order.id;
            });
    }

    const onApprove = async (data) => {

        // replace this url with your server
        const response = await fetch("https://react-paypal-js-storybook.fly.dev/api/paypal/capture-order", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                orderID: data.orderID,
            }),
        });
        const orderData = await response.json();
    }
    const ButtonWrapper = ({ showSpinner }) => {
        const [{ isPending }] = usePayPalScriptReducer();
    
        return (
            <>
                { (showSpinner && isPending) && <div className="spinner" /> }
                <PayPalButtons
                    fundingSource="paypal"
                    style={{"layout":"vertical","label":"donate"}}
                    disabled={false}
                    forceReRender={[style]}
                    createOrder={createOrder}
                    onApprove={onApprove}
                />
            </>
        );
    }
    const handleAmountChange = (e) => {
        setDonationAmount(parseFloat(e.target.value)); // Update donationAmount with custom value
      }
    return (
        <div>
            <input 
                type="number" 
                value={donationAmount} // Use otherAmount state here
                onChange={handleAmountChange} // Use separate handler
                placeholder="Enter Amount" 
            />
            <PayPalScriptProvider options={{ clientId: "test", components: "buttons", currency: "USD" }}>
                <ButtonWrapper showSpinner={false} />
            </PayPalScriptProvider>
        </div>
    );
};

export default DonateButton;


